export function getMousePos(dataGraphics, xmapped, ymapped){
    
    if(+xmapped % +dataGraphics.nx !== 0){
        var differencex = +xmapped % +dataGraphics.nx
        var xsnapped = 0;
        if (+xmapped % +dataGraphics.nx < dataGraphics.nx/2){
            xsnapped = xmapped.toFixed(2) - differencex.toFixed(2)
        }
        if (+xmapped % +dataGraphics.nx > dataGraphics.nx/2){
            xsnapped = +xmapped.toFixed(2) - +differencex.toFixed(2) + +dataGraphics.nx
        }
    }

    //console.log(dataGraphics)

    //posição do mouse em y
    if(+ymapped % +dataGraphics.ny !== 0){
        var differencey = +ymapped % +dataGraphics.ny
        var ysnapped = 0;
        if (+ymapped % +dataGraphics.ny < dataGraphics.ny/2){
            ysnapped = ymapped.toFixed(2) - differencey.toFixed(2)
            //console.log(ysnapped)
        }
        if (+ymapped % +dataGraphics.ny > dataGraphics.ny/2){
            ysnapped = +ymapped.toFixed(2) - +differencey.toFixed(2) + +dataGraphics.ny
            //console.log(ysnapped)
        }
    }

    return {
        xsnapped,
        ysnapped
    }

}